<div *ngIf="loading">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2" fill="transparent"
    animationDuration=".5s">
  </p-progressSpinner>
</div>

<div class="menu-container margin-top-16" *ngIf="!loading && !showMessageType">
  <div class="menu-card-container" *ngFor="let messageTemplate of messageTemplates"
    (click)="selectMessageType(messageTemplate)">
    <div class="menu-card">
      <div class="menu-footer">
        <div class="flex">
          <div>
            {{ appConfig.getCustomLabelForMessageTag(messageTemplate.eventTag, (messageTemplate.eventTag+'_title'
            | translate : {ServiceFollowUpReminderMonths :
            partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService :
            partner.ReminderHoursBeforeService, WaitingDelayHours : partner.WaitingDelayHours,
            OtherServiceFollowUpReminderMonths : partner.OtherServiceFollowUpReminderMonths,
            PostServiceFollowUpDays : partner.PostServiceFollowUpDays }), false) }}
          </div>
          <div *ngIf="!messageTemplate.disableMessaging">
            <span class="hubtiger-mail"
              [ngClass]="{'configured' : messageTemplate.emailTemplateActive && messageTemplate.emailTemplate.length>0}"></span>
            <span class="hubtiger-sms" [ngClass]="{'configured' : messageTemplate.shortMessageTemplateActive}"></span>
          </div>
        </div>
        <div class="footer-description">
          {{
          appConfig.getCustomLabelForMessageTag(messageTemplate.eventTag, (messageTemplate.eventTag
          +'_description' | translate : {ServiceFollowUpReminderMonths :
          partner.ServiceFollowUpReminderMonths, ReminderHoursBeforeService : partner.ReminderHoursBeforeService,
          WaitingDelayHours : partner.WaitingDelayHours, OtherServiceFollowUpReminderMonths :
          partner.OtherServiceFollowUpReminderMonths,
          PostServiceFollowUpDays : partner.PostServiceFollowUpDays}), true)
          }}
        </div>
        <!-- <div class="margin-top-8">
        <span class="hubtiger-mail"
          [ngClass]="{'configured' : messageTemplate.IsActive && messageTemplate.Template.length>0}"></span>
        <span class="hubtiger-sms" [ngClass]="{'configured' : messageTemplate.ShortMessageActive}"></span>
      </div> -->
      </div>
    </div>
  </div>
</div>

<div *ngIf="showMessageType">
  <app-service-type-message-template [selectedMessageTemplate]="selectedMessageTemplate" [messageTemplates]="parentMessageTemplates" (closePanel)="closePanel($event)"></app-service-type-message-template>
</div>

<!-- <p-sidebar [(visible)]="showMessageType" position="right" [style]="{width:'90em', background: '#F6F6F8', 'overflow-x': 'auto'}" [autoZIndex]="false" [baseZIndex]="1004" (onHide)="getServiceTypeServiceTypes()">
  <div *ngIf="showMessageType">
    <app-service-type-message-template [selectedMessageTemplate]="selectedMessageTemplate" [messageTemplates]="parentMessageTemplates"></app-service-type-message-template>
  </div>
</p-sidebar> -->